<!--选择工人穿梭框-->
<template>
  <el-dialog :visible="visible"
             :append-to-body="true"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="closeBefore"
             title="选择工友"
             destroy-on-close
             width="700px"
  >
    <div class="content">
      <div>
        <worker-management @end="getWorkerList" isBzjz></worker-management>
      </div>
      <div>
        <el-transfer
          filterable
          filter-placeholder="请输入工友姓名"
          :titles="['工友列表', '已选工友列表']"
          v-model="workerDataSelected"
          :data="workerDataAll"
          target-order="push"
          :props="{
            key: 'no',
            label: 'name'
          }"
        >
        </el-transfer>
      </div>
    </div>
    <div slot="footer" class="flex_jc_center footer">
      <el-button @click="closeBefore">取消</el-button>
      <el-button class="saveBtn" @click="save" type="primary" style="margin-left:20px">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {api} from "@/api/apiRecord"

export default {
  name: "SelectWorker",
  components: {
    WorkerManagement: () => import('@/views/record/components/worker-management/WorkerManagement.vue') // 工友管理
  },
  props:{
      isBzjz: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      visible: false,
      workerDataAll: [], // 所有工友数据
      workerDataSelected: [] // 被选中的工友数据
    }
  },
  methods: {
    /**
     * 打开选择工人模态框
     *
     * @param selected {Array} 传入被选中的值组成的数组
     *
     * */
    open(selected) {
      this.workerDataSelected = selected
      this.getWorkerList()
      this.visible = true
    },
    /*
    * 关闭选择工人模态框
    * */
    closeBefore() {
      this.visible = false
      this.workerDataAll = []
      this.workerDataSelected = []
    },
    /*
    * 保存选择的数据并关闭模态框
    * */
    save() {
      const workerInfoArr = this.workerDataSelected.map(no => this.workerDataAll.find(item => item.no === no))
      this.$emit('save', this.workerDataSelected, workerInfoArr)
      if(this.workerDataSelected.length>20){
        this.$message.warning('最多选择20个工友')
        return
      }
      this.closeBefore()
    },
    /*
    * 获取所有的工人列表
    * */
    async getWorkerList() {
      const type = this.$route.query.type ? this.$route.query.type : '1'
      const res = await api.getWorkerList(type)
      if (res.data.code === 200) {
        this.workerDataAll = res.data.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 30px 0px;
  /deep/ .el-transfer {
    display: flex;
    justify-content: space-between;
    max-height: 520px;

    .el-transfer-panel__header {
      border-bottom: none;
    }

    .el-transfer-panel__item {
      padding-left: 20px;
      color: #333333;
    }

    .el-transfer-panel {
      width: 280px;
      height: 519px;
      flex-shrink: 0;
      border-color: #DEDEE0;
    }

    .el-transfer__button {
      width: 28px;
      height: 28px;
      padding: 0;
      margin: 10px 0;
      color: #fff !important;
      border-color: #B79255 !important;
      background: #B79255!important;
    }

    .el-transfer__buttons {
      padding: 0;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
    }

    .el-transfer-panel__header {
      background-color: #fff;
      position: relative;

      &:after {
        position: absolute;
        left: 10px;
        content: '';
        height: 1px;
        width: 260px;
        background-color: #DEDEE0;
      }

      .el-checkbox .el-checkbox__label {
        color: #666;

        span {
          color: #969696
        }
      }
    }

    .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span {
      position: initial;
      padding-left: 5px;
    }

    .el-transfer-panel__filter {
      margin: 0 10px 10px;

      .el-input__inner {
        padding-left: 10px;
        padding-right: 30px;
        border-radius: 0;
      }

      .el-input__prefix {
        left: initial;
        right: 0;

      }

      .el-icon-circle-close {
        color: #91949A !important;
      }
    }

    .el-transfer-panel__empty {
      height: 404px;
      //color: transparent;
      position: relative;

      &:after{
        position: absolute;
        left: 0;
        top: 0;
        content: '暂无数据';
        background-color: #fff;
        color: #666666;
        height: 414px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .el-transfer-panel__body {
      padding-top: 10px;
      height: 469px
    }

    .el-transfer-panel__list.is-filterable {
      height: 424px;
    }
  }

  /deep/ .el-button--default {
    color: #B79255 !important;
    border-color: #B79255 !important;
    border-radius: 4px;
    margin-left: 0 !important;
    margin-bottom: 20px;
  }
  /deep/ .el-button--primary {
    color: #B79255 !important;
    border-color: #B79255 !important;
    background: #fff!important;
    margin-left: 0 !important;
    margin-bottom: 20px;
    height: 34px;
    width: 86px;
    padding: 0px 15px;
  }
  }
.footer {
  .el-button{
    width: 58px;
    padding: 9px 12px;
  }
  .saveBtn{
    color: #fff !important;
    border-color: #B79255 !important;
    background: #B79255;
  }
}
</style>
